import styled from 'styled-components'
import tw from 'twin.macro'

import mastheadLeft from './blu-notte/masthead_left.jpg'

export const Root = styled.main`
  min-height: 100vh;
  color: #fff;
  background: #1b263c;
  font-family: var(--font-pragmatica);
  font-weight: 300;
  font-size: 1.125rem;
  line-height: 1.75rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`

export const Masthead = styled.div`
  ${tw`max-w-watchesMaxFlush mx-auto grid grid-cols-1 md:grid-cols-2 items-center justify-items-center`}
  background-image: url(${mastheadLeft.src});
  background-position: top left;
  background-repeat: no-repeat;
  background-size: contain;

  & > *:first-child {
    ${tw`py-24 md:py-0 px-12 md:px-0`};
  }
`
